import React from 'react';
import styled from 'styled-components';

const TextArea = styled.textarea`
  box-shadow: none !important;
  border-radius: 0 !important;
  border: none !important;
`;

const TextAreaGroup = ({ errors, label, ...otherProps }) => (
  <div className="field">
    {label && (
      <div className="py-2 has-background-white">
        <label className="px-4 has-text-weight-bold"> {label} </label>
      </div>
    )}
    <div className="control">
      <TextArea className="textarea pt-3" {...otherProps} />
      {errors && <p className="help is-danger">{errors}</p>}
    </div>
  </div>
);

export default TextAreaGroup;
